import { BooleanFilterEnum } from '../../../enums/boolean-filter.enum';
import { ApiRequestFilters } from '../../../types/api-request-filters';
import { VehicleFeatureItemTypeEnum } from '../enums/vehicle-feature-item-type.enum';

/**
 * Vehicle feature items filters
 */
export class VehicleFeatureItemsFilters extends ApiRequestFilters {
	/**
	 * Types
	 */
	types?: VehicleFeatureItemTypeEnum[];

	/**
	 * Hidden value
	 */
	hidden?: BooleanFilterEnum;
}
